import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const RupeshPandey = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Rupesh Pandey"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Rupesh-Pandey-min.jpg"
                bio="Assistant General Manager, JSW"
            />
        </>
    );
};

export default RupeshPandey;